/* ============================================================
   dbakers Signature Cake Builder JS — Same-Day edition
   ADA compliant — aria-expanded, aria-live, disabled guards

   ── Same-day variant ──
   The DIETARY step has been removed. All diet/nut/GF/vegan state,
   bindings, acknowledgments, warnings, and the gluten-free cart line
   item are gone. Size now opens "Make it special" directly. Everything
   else (add-ons, candles multi-select, extras, two-step cart submit,
   verify, cart badge) is unchanged from the pre-order builder.

   Variant ID lookups come from window.dbsb*Variants and
   window.dbsbAddonIds (exported from Liquid). No hardcoded IDs.
   ============================================================ */

(function () {
  'use strict';

  var ADDON_IDS    = window.dbsbAddonIds        || {};
  var PLAQUE_IDS   = window.dbsbPlaqueVariants  || {};
  var TOPPER_IDS   = window.dbsbTopperVariants  || {};
  var CANDLE_IDS   = window.dbsbCandleVariants  || {};
  var METALLIC_IDS = window.dbsbMetallicVariants || {};

  var state = {
    variantId: null,
    basePrice: 0,
    sizeName: '',
    addons: {
      message:  { selected: false, color: '', text: '' },
      candles:  {
        selected: false,
        types: {
          rainbow:   { active: false },
          sparklers: { active: false },
          metallic:  { active: false, color: '' },
          number:    { active: false, color: '', number: '' }
        }
      },
      topper:   { selected: false, color: '' },
      gift:     { selected: false, text: '' }
    },
    extras: {
      bow:      { selected: false, price: 5.25 },
      server:   { selected: false, price: 2.00 }
    }
  };

  /* ── Init ── */
  function init() {
    if (!document.getElementById('dbsb-root')) return;
    bindSectionHeaders();
    bindSizeCards();
    bindAddonRows();
    bindCandleTypes();
    bindImageTiles();
    bindMsgInput();
    bindGiftInput();
    bindCandleNumber();
    bindExtraCards();
    bindStickyBtn();
    updateSticky();
    openSection('size');
    maybeAutoSelectSingleSize();
  }

  /* ── Single-size auto-select ──
     When the cake has only one variant, there's no choice to make —
     select it on load so the price + Add to cart are live immediately
     and the customer can go straight to add-ons. The Liquid sets
     data-single-size="true" on #dbsb-root and shows the "only size
     available today" note + heading. Multi-size cakes skip this. */
  function maybeAutoSelectSingleSize() {
    var root = document.getElementById('dbsb-root');
    if (!root || root.dataset.singleSize !== 'true') return;
    var card = document.querySelector('.dbsb-size-card:not([disabled])');
    if (!card) return;
    /* Set state directly rather than .click() — the click handler would
       collapse step 1 and auto-open add-ons, which we don't want for a
       forced single size. Here we just mark it selected and light up the
       sticky bar, leaving step 1 visible (with its "today" note) and the
       add-ons step closed for the customer to open if they wish. */
    document.querySelectorAll('.dbsb-size-card').forEach(function (c) {
      c.classList.remove('is-selected');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-checked', 'true');
    state.variantId = card.dataset.variantId;
    state.basePrice = parseFloat(card.dataset.variantPrice) / 100;
    state.sizeName  = card.dataset.variantDisplay || card.dataset.variantTitle;
    syncVariantInput();
    markSectionDone('size');
    var stickyBtn = document.getElementById('dbsb-sticky-btn');
    if (stickyBtn) stickyBtn.classList.add('is-active');
    updateSticky();
  }

  if (document.readyState === 'complete') {
    setTimeout(init, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(init, 300); });
  }

  /* ── Section accordion ── */
  function openSection(id) {
    var body = document.getElementById('dbsb-body-' + id);
    var header = document.querySelector('[data-section="' + id + '"]');
    if (body) body.classList.add('is-open');
    if (header) header.setAttribute('aria-expanded', 'true');
  }

  function closeSection(id) {
    var body = document.getElementById('dbsb-body-' + id);
    var header = document.querySelector('[data-section="' + id + '"]');
    if (body) body.classList.remove('is-open');
    if (header) header.setAttribute('aria-expanded', 'false');
  }

  function bindSectionHeaders() {
    document.querySelectorAll('.dbsb-section-header').forEach(function (header) {
      header.addEventListener('click', function (e) {
        e.stopPropagation();
        var id   = this.dataset.section;
        var body = document.getElementById('dbsb-body-' + id);
        if (body) {
          body.classList.toggle('is-open');
          this.setAttribute('aria-expanded', body.classList.contains('is-open') ? 'true' : 'false');
        }
      });
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* ── Size cards ── */
  function bindSizeCards() {
    document.querySelectorAll('.dbsb-size-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (this.disabled) return;
        document.querySelectorAll('.dbsb-size-card').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        state.variantId = this.dataset.variantId;
        state.basePrice = parseFloat(this.dataset.variantPrice) / 100;
        state.sizeName  = this.dataset.variantDisplay || this.dataset.variantTitle;
        syncVariantInput();
        markSectionDone('size');
        var stickyBtn = document.getElementById('dbsb-sticky-btn');
        if (stickyBtn) stickyBtn.classList.add('is-active');
        updateSticky();
        closeSection('size');
        /* Same-day: no dietary step — open "Make it special" directly. */
        openSection('special');
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* ── Addon rows ── */
  function bindAddonRows() {
    document.querySelectorAll('.dbsb-addon-row').forEach(function (row) {
      row.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id    = this.dataset.addon;
        var card  = document.getElementById('dbsb-addon-card-' + id);
        var panel = document.getElementById('dbsb-sub-panel-' + id);
        if (!card) return;
        var isOpen = card.classList.contains('is-selected');
        card.classList.toggle('is-selected', !isOpen);
        if (panel) {
          panel.classList.toggle('is-open', !isOpen);
          panel.setAttribute('aria-hidden', String(isOpen));
        }
        this.setAttribute('aria-expanded', String(!isOpen));
        if (state.addons[id]) state.addons[id].selected = !isOpen;
        if (isOpen) resetAddon(id);
        updateSticky();
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  function resetAddon(id) {
    if (id === 'message') {
      state.addons.message.color = state.addons.message.text = '';
      document.querySelectorAll('[data-tile-group="msg-color"]').forEach(function (t) { t.classList.remove('is-selected'); });
      var wrap = document.getElementById('dbsb-msg-input-wrap');
      if (wrap) wrap.classList.remove('is-visible');
      var inp  = document.getElementById('dbsb-msg-text');
      if (inp)  inp.value = '';
      var cnt  = document.getElementById('dbsb-msg-char-count');
      if (cnt)  cnt.textContent = '0';
    }
    if (id === 'candles') {
      state.addons.candles.types.rainbow.active   = false;
      state.addons.candles.types.sparklers.active = false;
      state.addons.candles.types.metallic.active  = false;
      state.addons.candles.types.metallic.color   = '';
      state.addons.candles.types.number.active    = false;
      state.addons.candles.types.number.color     = '';
      state.addons.candles.types.number.number    = '';
      document.querySelectorAll('.dbsb-type-pill').forEach(function (p) {
        p.classList.remove('is-selected');
        p.setAttribute('aria-checked', 'false');
      });
      document.querySelectorAll('.dbsb-candle-sub').forEach(function (el) {
        el.classList.remove('is-visible');
      });
      document.querySelectorAll('[data-tile-group^="candle-color-"]').forEach(function (t) {
        t.classList.remove('is-selected');
        t.setAttribute('aria-checked', 'false');
      });
      var cn = document.getElementById('dbsb-candle-number');
      if (cn) cn.value = '';
    }
    if (id === 'topper') {
      state.addons.topper.color = '';
      document.querySelectorAll('[data-tile-group="topper-color"]').forEach(function (t) { t.classList.remove('is-selected'); });
    }
    if (id === 'gift') {
      state.addons.gift.text = '';
      var ta = document.getElementById('dbsb-gift-text');
      if (ta) ta.value = '';
    }
  }

  /* ── Candle type pills — multi-select ── */
  function bindCandleTypes() {
    document.querySelectorAll('.dbsb-type-pill').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var type = this.dataset.type;
        var typeState = state.addons.candles.types[type];
        if (!typeState) return;

        typeState.active = !typeState.active;
        this.classList.toggle('is-selected', typeState.active);
        this.setAttribute('aria-checked', typeState.active ? 'true' : 'false');

        var sub = document.getElementById('dbsb-candle-sub-' + type);
        if (sub) sub.classList.toggle('is-visible', typeState.active);

        if (!typeState.active) {
          if (type === 'metallic') typeState.color = '';
          if (type === 'number')   { typeState.color = ''; typeState.number = ''; }
          document.querySelectorAll('[data-tile-group="candle-color-' + type + '"]').forEach(function (t) {
            t.classList.remove('is-selected');
            t.setAttribute('aria-checked', 'false');
          });
          if (type === 'number') {
            var cn = document.getElementById('dbsb-candle-number');
            if (cn) cn.value = '';
          }
        }
        updateSticky();
      });
      pill.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* ── Image tiles ── */
  function bindImageTiles() {
    document.querySelectorAll('.dbsb-img-tile').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var group = this.dataset.tileGroup;
        if (!group) return;
        document.querySelectorAll('[data-tile-group="' + group + '"]').forEach(function (t) {
          t.classList.remove('is-selected');
          t.setAttribute('aria-checked', 'false');
        });
        this.classList.add('is-selected');
        this.setAttribute('aria-checked', 'true');
        var color = this.dataset.tileValue;
        if (group === 'msg-color') {
          state.addons.message.color = color;
          var wrap = document.getElementById('dbsb-msg-input-wrap');
          if (wrap) {
            wrap.classList.add('is-visible');
            var inp = document.getElementById('dbsb-msg-text');
            if (inp) setTimeout(function () { inp.focus(); }, 100);
          }
        } else if (group === 'candle-color-metallic') {
          state.addons.candles.types.metallic.color = color;
          updateSticky();
        } else if (group === 'candle-color-number') {
          state.addons.candles.types.number.color = color;
          updateSticky();
        } else if (group === 'topper-color') {
          state.addons.topper.color = color;
        }
      });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* ── Message input ── */
  function bindMsgInput() {
    var inp = document.getElementById('dbsb-msg-text');
    if (!inp) return;
    inp.addEventListener('input', function () {
      state.addons.message.text = this.value;
      var cnt = document.getElementById('dbsb-msg-char-count');
      if (cnt) cnt.textContent = this.value.length;
    });
  }

  /* ── Gift input ── */
  function bindGiftInput() {
    var ta = document.getElementById('dbsb-gift-text');
    if (!ta) return;
    ta.addEventListener('input', function () { state.addons.gift.text = this.value; });
  }

  /* ── Candle number input ── */
  function bindCandleNumber() {
    var inp = document.getElementById('dbsb-candle-number');
    if (!inp) return;
    inp.addEventListener('input', function () {
      var cleaned = String(this.value || '').replace(/\D/g, '').slice(0, 2);
      if (cleaned !== this.value) this.value = cleaned;
      state.addons.candles.types.number.number = cleaned;
      updateSticky();
    });
  }

  /* ── Extra cards ── */
  function bindExtraCards() {
    document.querySelectorAll('.dbsb-extra-card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = this.dataset.extra;
        if (!state.extras[id]) return;
        state.extras[id].selected = !state.extras[id].selected;
        this.classList.toggle('is-selected', state.extras[id].selected);
        this.setAttribute('aria-checked', String(state.extras[id].selected));
        updateSticky();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* ── Validation ── */
  function validateAddons() {
    var errors = [];

    if (state.addons.message.selected) {
      if (!state.addons.message.color) {
        errors.push({ id: 'dbsb-addon-card-message', msg: 'Please choose a plaque color for your message.' });
      } else if (!state.addons.message.text || !state.addons.message.text.trim()) {
        errors.push({ id: 'dbsb-addon-card-message', msg: 'Please enter the message for your plaque.' });
      }
    }

    if (state.addons.candles.selected) {
      var ts = state.addons.candles.types;
      var anyActive = ts.rainbow.active || ts.sparklers.active || ts.metallic.active || ts.number.active;
      if (!anyActive) {
        errors.push({ id: 'dbsb-addon-card-candles', msg: 'Please choose at least one candle type, or deselect candles.' });
      } else if (ts.metallic.active && !ts.metallic.color) {
        errors.push({ id: 'dbsb-addon-card-candles', msg: 'Please choose a color for your metallic candles.' });
      } else if (ts.number.active && !ts.number.color) {
        errors.push({ id: 'dbsb-addon-card-candles', msg: 'Please choose a color for your number candles.' });
      } else if (ts.number.active && (!ts.number.number || !ts.number.number.toString().trim())) {
        errors.push({ id: 'dbsb-addon-card-candles', msg: 'Please enter the number for your candles.' });
      }
    }

    if (state.addons.topper.selected && !state.addons.topper.color) {
      errors.push({ id: 'dbsb-addon-card-topper', msg: 'Please choose a color for your topper.' });
    }

    return errors;
  }

  function showValidationErrors(errors) {
    document.querySelectorAll('.dbsb-addon-error').forEach(function(el) {
      el.style.display = 'none'; el.textContent = '';
    });
    document.querySelectorAll('.dbsb-addon-card.has-error').forEach(function(el) {
      el.classList.remove('has-error');
    });

    if (errors.length === 0) return true;

    var first = errors[0];
    errors.forEach(function(err) {
      var card = document.getElementById(err.id);
      if (!card) return;
      card.classList.add('has-error');
      var errEl = card.querySelector('.dbsb-addon-error');
      if (!errEl) {
        errEl = document.createElement('div');
        errEl.className = 'dbsb-addon-error';
        card.appendChild(errEl);
      }
      errEl.textContent = err.msg;
      errEl.style.display = 'block';
    });

    var firstCard = document.getElementById(first.id);
    if (firstCard) {
      firstCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return false;
  }

  /* ── Sticky ATC ── */
  function bindStickyBtn() {
    var btn = document.getElementById('dbsb-sticky-btn');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (!state.variantId) return;
      var errors = validateAddons();
      if (!showValidationErrors(errors)) return;
      submitCart();
    });
  }

  /* ── Cart — two-step submit (cake first, add-ons tagged with its key) ── */
  function submitCart() {
    var btn = document.getElementById('dbsb-sticky-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    var expectedTotal = calcTotal();

    /* Step 1: cake alone */
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: state.variantId, quantity: 1, properties: buildProperties() }]
      })
    })
    .then(function (r) {
      return r.json().then(function (data) {
        return { ok: r.ok, status: r.status, data: data };
      });
    })
    .then(function (res) {
      if (!res.ok) {
        if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
        console.error('dbsb cake-add error:', res.status, res.data);
        var msg = (res.data && (res.data.description || res.data.message)) || 'Please try again.';
        alert('Something went wrong: ' + msg);
        return;
      }

      var cakeKey = res.data && res.data.items && res.data.items[0] && res.data.items[0].key
                  ? res.data.items[0].key
                  : null;
      var addons = buildAddonItems(cakeKey);

      if (!addons.length) {
        verifyAndFinish(btn, expectedTotal);
        return;
      }

      /* Step 2: add-ons batched, all tagged with cakeKey. */
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: addons })
      })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, status: r.status, data: data };
        });
      })
      .then(function (addonRes) {
        if (!addonRes.ok) {
          console.error('dbsb addon-add error:', addonRes.status, addonRes.data);
          var amsg = (addonRes.data && (addonRes.data.description || addonRes.data.message)) || 'Some extras couldn\'t be added.';
          alert('Your cake was added, but: ' + amsg + ' Please review your cart.');
          if (btn) btn.textContent = 'Added (with issues)';
          setTimeout(function () { window.location.href = '/cart'; }, 600);
          return;
        }
        verifyAndFinish(btn, expectedTotal);
      });
    })
    .catch(function (err) {
      console.error('dbsb cart error:', err);
      if (btn) { btn.textContent = 'Add to cart'; btn.disabled = false; }
      alert('We couldn\'t reach the cart. Check your connection and try again.');
    });
  }

  /* ── Verify cart total + redirect ── */
  function verifyAndFinish(btn, expectedTotal) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cakeItems = cart.items.filter(function (i) {
          return !(i.properties && i.properties._addon_for);
        });
        var latestCake = cakeItems[cakeItems.length - 1];
        var cakeKey = latestCake ? latestCake.key : null;
        var related = cart.items.filter(function (i) {
          return i.key === cakeKey || (i.properties && i.properties._addon_for === cakeKey);
        });
        var actualTotal = related.reduce(function (s, i) { return s + (i.line_price / 100); }, 0);

        if (Math.abs(expectedTotal - actualTotal) > 0.02) {
          console.warn(
            'dbsb price mismatch — promised $' + expectedTotal.toFixed(2) +
            ', cart shows $' + actualTotal.toFixed(2) +
            ' (diff $' + (expectedTotal - actualTotal).toFixed(2) + '). ' +
            'Some add-on variant likely failed to resolve.'
          );
          console.log('dbsb cart lines for this cake:');
          related.forEach(function (i) {
            console.log('  · ' + i.product_title + ' — ' + (i.variant_title || '') + ' × ' + i.quantity + ' = $' + (i.line_price / 100).toFixed(2));
          });
        }
        onCartSuccess(btn);
      })
      .catch(function (err) {
        console.error('dbsb cart verify error:', err);
        onCartSuccess(btn);
      });
  }

  /* ── Cart success — flash, refresh badge, redirect ── */
  function onCartSuccess(btn) {
    if (btn) btn.textContent = 'Added! ✓';
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:change',  { bubbles: true }));
    setTimeout(function () { window.location.href = '/cart'; }, 400);
  }

  /* ── Build add-on line items ──
     Same-day: no gluten-free line item (dietary step removed). */
  function buildAddonItems(cakeKey) {
    var items = [];
    var tag = cakeKey ? { '_addon_for': cakeKey } : {};

    if (state.addons.message.selected && state.addons.message.color) {
      var pid = PLAQUE_IDS[state.addons.message.color];
      if (pid) items.push({
        id: pid,
        quantity: 1,
        properties: Object.assign({
          'Message': state.addons.message.text,
          '_addon': 'Sugar plaque'
        }, tag)
      });
    }
    if (state.addons.candles.selected) {
      var ts = state.addons.candles.types;
      if (ts.rainbow.active && ADDON_IDS.rainbowCandles) {
        items.push({
          id: ADDON_IDS.rainbowCandles,
          quantity: 1,
          properties: Object.assign({ '_addon': 'Rainbow candles' }, tag)
        });
      }
      if (ts.sparklers.active && ADDON_IDS.sparklers) {
        items.push({
          id: ADDON_IDS.sparklers,
          quantity: 1,
          properties: Object.assign({ '_addon': 'Sparklers' }, tag)
        });
      }
      if (ts.metallic.active && ts.metallic.color) {
        var mid = METALLIC_IDS[ts.metallic.color];
        if (mid) {
          items.push({
            id: mid,
            quantity: 1,
            properties: Object.assign({ '_addon': 'Metallic candles (' + ts.metallic.color + ')' }, tag)
          });
        } else {
          console.warn('dbsb: metallic candle variant not found for color:', ts.metallic.color);
        }
      }
      if (ts.number.active && ts.number.color && ts.number.number) {
        var nid = CANDLE_IDS[ts.number.color];
        var numDigits = String(ts.number.number).replace(/\D/g, '').length || 1;
        if (nid) {
          items.push({
            id: nid,
            quantity: numDigits,
            properties: Object.assign({
              'Number': ts.number.number,
              '_addon': 'Number candles (' + ts.number.color + ')'
            }, tag)
          });
        } else {
          console.warn('dbsb: number candle variant not found for color:', ts.number.color);
        }
      }
    }
    if (state.addons.topper.selected && state.addons.topper.color) {
      var tid = TOPPER_IDS[state.addons.topper.color];
      if (tid) items.push({
        id: tid,
        quantity: 1,
        properties: Object.assign({ '_addon': 'Birthday topper' }, tag)
      });
    }
    if (state.extras.bow.selected      && ADDON_IDS.bow) {
      items.push({
        id: ADDON_IDS.bow,
        quantity: 1,
        properties: Object.assign({ '_addon': 'XL Gold Bow' }, tag)
      });
    }
    if (state.extras.server.selected   && ADDON_IDS.cakeServer) {
      items.push({
        id: ADDON_IDS.cakeServer,
        quantity: 1,
        properties: Object.assign({ '_addon': 'Cake server' }, tag)
      });
    }
    return items;
  }

  function buildProperties() {
    var props = {};
    if (state.addons.message.selected) props['Message plaque'] = state.addons.message.color + ' — ' + state.addons.message.text;
    if (state.addons.candles.selected) {
      var ts2 = state.addons.candles.types;
      var parts = [];
      if (ts2.rainbow.active)   parts.push('Rainbow candles');
      if (ts2.sparklers.active) parts.push('Sparklers');
      if (ts2.metallic.active && ts2.metallic.color) parts.push('Metallic candles (' + ts2.metallic.color + ')');
      if (ts2.number.active && ts2.number.color && ts2.number.number) {
        parts.push('Number candles (' + ts2.number.color + ') — #' + ts2.number.number);
      }
      if (parts.length) props['Candles'] = parts.join(' + ');
    }
    if (state.addons.topper.selected)    props['Topper color']  = state.addons.topper.color;
    if (state.addons.gift.text && state.addons.gift.text.trim()) props['Gift message'] = state.addons.gift.text;
    if (state.extras.bow.selected)       props['XL Gold Bow']   = 'Yes';
    if (state.extras.server.selected)    props['Cake server']   = 'Yes';
    return props;
  }

  /* ── Sticky update ── */
  function calcTotal() {
    var total = state.basePrice;
    if (state.addons.message.selected)  total += 7.50;
    if (state.addons.topper.selected)   total += 7.50;
    if (state.addons.candles.selected) {
      var ts3 = state.addons.candles.types;
      if (ts3.rainbow.active)   total += 4.99;
      if (ts3.sparklers.active) total += 11.99;
      if (ts3.metallic.active && ts3.metallic.color) total += 4.99;
      if (ts3.number.active && ts3.number.color && ts3.number.number) {
        var digits = String(ts3.number.number).replace(/\D/g, '').length || 0;
        total += digits * 2;
      }
    }
    Object.keys(state.extras).forEach(function (k) {
      if (state.extras[k].selected) total += state.extras[k].price;
    });
    return total;
  }

  function updateSticky() {
    var total   = calcTotal();
    var nameEl  = document.getElementById('dbsb-sticky-name');
    var priceEl = document.getElementById('dbsb-sticky-price');
    var liveEl  = document.getElementById('dbsb-sticky-live');
    var btn     = document.getElementById('dbsb-sticky-btn');

    if (nameEl)  nameEl.textContent  = state.sizeName || 'Choose your size above';
    if (priceEl) priceEl.textContent = state.basePrice > 0 ? '$' + total.toFixed(2) : 'From $—';
    if (liveEl && state.sizeName) liveEl.textContent = state.sizeName + ' — $' + total.toFixed(2);
    if (btn) {
      if (state.variantId) {
        btn.classList.add('is-active');
        btn.textContent = btn.textContent === 'Add to cart' || btn.textContent === 'Added! ✓' ? btn.textContent : 'Add to cart';
      } else {
        btn.textContent = 'Add to cart';
      }
    }
  }

  /* ── Section done marker ── */
  function markSectionDone(id) {
    var num = document.getElementById('dbsb-num-' + id);
    if (num) num.classList.add('is-done');
  }

  /* ── Sync hidden variant input ── */
  function syncVariantInput() {
    var input = document.getElementById('dbsb-variant-id');
    if (input) input.value = state.variantId;
  }

})();

/* ── Cart badge count update ── */
(function () {
  var EVENTS = ['cart:refresh', 'cart:change', 'cart:update', 'cart-update'];
  var lastCount = -1;

  function refreshBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cakeCount = 0;
        cart.items.forEach(function (item) {
          var isAddon = false;
          if (item.properties) {
            Object.keys(item.properties).forEach(function (key) {
              if (key === '_addon' || key === '_addon_for') isAddon = true;
            });
          }
          if (!isAddon) cakeCount += item.quantity;
        });

        if (cakeCount === lastCount) return;
        lastCount = cakeCount;

        var badges = document.querySelectorAll('.dbn-cart-badge');
        badges.forEach(function (el) {
          el.textContent = cakeCount;
          el.style.display = cakeCount > 0 ? '' : 'none';
        });
        var bubbles = document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden)');
        bubbles.forEach(function (el) { el.textContent = cakeCount; });
      })
      .catch(function () { /* silent fail */ });
  }

  if (document.readyState === 'complete') {
    refreshBadge();
  } else {
    window.addEventListener('load', refreshBadge);
  }
  EVENTS.forEach(function (evt) {
    document.addEventListener(evt, refreshBadge);
  });
})();